
<template>
	<div class="modal_info confirm-close small-pad">
		<div class="header-submodal">
			<div class="image"><img src="/build/flappy/bird_confetti.png"></div>
			<div class="title">{{$t('sync_calendar.success_sync_title')}}</div>
		</div>
		<div class="description-modal">{{$t('sync_calendar.success_sync_desc')}}</div>

		<div class="button-actions">
			<button class="btn-tbf white center" @click="closeModal">
				<div class="text">{{ $t('general.ok_thanks') }}</div>
			</button>
			<a href="https://calendar.google.com/" target="_blank" class="btn-tbf blue center" @click="closeModal">
				<div class="loader"></div>
				<div class="text">{{ $t('sync_calendar.success_sync_btn') }}</div>
			</a>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		data() {
			return {

			};
		},
		async mounted() {
			
		},
		methods: {
			cancelClose(){
				this.$emit("cancel_close");
			},
			closeModal(){
				this.$emit("close_modal");
			},
		}
	};
</script>